export var ProductDonationRecurrenceInterval;
(function (ProductDonationRecurrenceInterval) {
    ProductDonationRecurrenceInterval["OneTime"] = "oneTime";
    ProductDonationRecurrenceInterval["Weekly"] = "weekly";
    ProductDonationRecurrenceInterval["BiWeekly"] = "biWeekly";
    ProductDonationRecurrenceInterval["Monthly"] = "monthly";
    ProductDonationRecurrenceInterval["Quarterly"] = "quarterly";
    ProductDonationRecurrenceInterval["Yearly"] = "yearly";
})(ProductDonationRecurrenceInterval || (ProductDonationRecurrenceInterval = {}));
export var Tribute;
(function (Tribute) {
    Tribute["InMemoryOf"] = "inMemoryOf";
    Tribute["InHonourOf"] = "inHonourOf";
})(Tribute || (Tribute = {}));
